module.exports = __webpack_public_path__ + "img/expand_less.c3f2f903.svg";